import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import reportWebVitals from './reportWebVitals';
import {RouterProvider} from 'react-router-dom';
import {router} from './core/routes/web';
import {
    HashRouter as Router,
    Routes,
    Route,
} from "react-router-dom";
import HomePage from "./v2/pages/HomePage";
import AboutUsPage from "./core/views/default/about";
import ContactsPage from "./core/views/default/contacts";
import LegalPage from "./core/views/default/legal";
import SitemapPage from "./core/views/default/site-map";
import NotFoundPage from "./core/views/default/404";
import SellHouse from "./v2/pages/SellHouse";
import RentHouse from "./v2/pages/RentHouse";
import HlushmanHouseCard from "./v1/HlushmanHouseCard";
import Layout from "./core/views/template/layout";
import { GoogleReCaptchaProvider } from 'react-google-recaptcha-v3';
import {ScrollToHashElement} from "./v2/components/ScrollToHashElement";

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
    <React.StrictMode>
        {/*<RouterProvider router={router} />*/}
        <GoogleReCaptchaProvider
            reCaptchaKey={process.env.REACT_APP_RECAPTCHA_SITE_KEY_v3}
            scriptProps={{
                async: true,
                defer: true,
                appendTo: 'head',
            }}
        >
            <Router>
                <ScrollToHashElement />
                <Routes>
                    {/*v2*/}
                    <Route exact path="/" element={<Layout child={<HomePage/>}/>}/>
                    <Route path="/about" element={<Layout child={<AboutUsPage/>}/>}/>
                    <Route path="/contacts" element={<Layout child={<ContactsPage/>}/>}/>
                    <Route path="/legal/:document" element={<Layout child={<LegalPage/>}/>}/>
                    <Route path="/sitemap" element={<SitemapPage/>}/>
                    <Route path="*" element={<NotFoundPage/>}/>

                    <Route path="/sell-house" element={<SellHouse/>}/>
                    <Route path="/rent-house" element={<RentHouse/>}/>

                    {/*v1*/}
                    <Route path="/links" element={<HlushmanHouseCard/>}/>
                </Routes>

            </Router>
        </GoogleReCaptchaProvider>

    </React.StrictMode>
);

reportWebVitals();
